import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from, lastValueFrom, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { environment } from 'src/environments/environment';
import { OktaAuth } from '@okta/okta-auth-js';
import { TabTokenService } from './tab-token.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class OktaAuthInterceptor implements HttpInterceptor {
  private oktaConfig = inject(OKTA_CONFIG);
  private tabTokenService = inject(TabTokenService);
  private authService = inject(AuthService);
  private router = inject(Router);
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only attach token for requests to our API
    if (req.url.startsWith(environment.apiUrl)) {
      const localToken = environment.enableLocalTestAuth
        ? window.sessionStorage.getItem('local-access-token')
        : null;
      if (localToken) {
        return next.handle(req.clone({
          setHeaders: { Authorization: `Bearer ${localToken}` }
        })).pipe(
          catchError(error => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
              this.authService.clearCurrentTabSession();
              void this.router.navigate(['/security-login'], { replaceUrl: true });
            }
            return throwError(() => error);
          })
        );
      }

      const oktaAuth: OktaAuth = this.oktaConfig.oktaAuth;
        return from((async () => {
          await this.tabTokenService.ensureUniqueAccessToken();
          const token = oktaAuth.getAccessToken();
          if (token) {
            const authReq = req.clone({
              setHeaders: { Authorization: `Bearer ${token}` }
            });
            return await lastValueFrom(next.handle(authReq));
          } else {
            return await lastValueFrom(next.handle(req));
          }
        })());
    }
    // Pass through unchanged for non-API requests
    return next.handle(req);
  }
}
